import { _StoredObjects } from "../../api/_StoredObjects";
import { CombinedProducts } from "../../api/compute/CombinedProducts";
import { CombinedStrategies } from "../../api/compute/CombinedStrategies";
import { Lists } from "../../api/compute/Lists";
import { Publications } from "../../api/compute/Publications";
import { Rankings } from "../../api/compute/Ranking";
import { Strategies } from "../../api/compute/Strategies";
import { SystematicProducts } from "../../api/compute/SystematicProducts";
import { SHARED_OBJECT_TYPE_SERVER_TO_UI } from "../../api/compute/_CommonPublicationsSubscriptions";
import { httpAll } from "../../httpAll";

export const publicationsGet = async (userData) => {
  // const _screening = await new Publications().select({ type: "screening", user_id: userData.id });
  

  var requests = {
    lists: new Lists(userData).get(),
    publications: new Publications().get({ user_id: userData.id }),
    rankings: new Rankings(userData).get(null),
    strategies: new Strategies(userData).get(null),
    systematicPortfolios: new SystematicProducts().get({
      ownerId: userData.id,
    }),
    combinedStrategies: new CombinedStrategies().get(
      null,
      undefined,
      userData.id
    ),
    combinedProducts: new CombinedProducts().get(null, undefined, userData.id),
    screening: await new _StoredObjects().get(null,"SCREENING",userData.id),
    // screening: new Publications().get({ type: "screening" }),
  };
  return httpAll(requests).then(
    (response) => _decodePublicationsGet(response),
    (error) => {
      throw new Error(error);
    }
  );
};

export const _decodePublicationsGet = (response) => {
  var objectTypes = SHARED_OBJECT_TYPE_SERVER_TO_UI;
  function filter(property, value) {
    return function (item) {
      if (item[property] === value) {
        return true;
      }
      return false;
    };
  }

  function map(type) {
    return function (item) {
      item._s_id = type + "_" + item.id;
      item.pubSubType = objectTypes[item.type];
      item.publicationId = null;
      if (publicationsMap[type] && item.id in publicationsMap[type]) {
        item.publicationId = publicationsMap[type][item.id].publicationId;
      }
      return item;
    };
  }
  // function screeningMap(type) {
  //   return function (item) {
  //     item._s_id = type + "_" + item.id;
  //     item.pubSubType = objectTypes[item.type];
  //     item.publicationId = null;
  //     if (publicationsMap[type] && item.id in publicationsMap[type]) {
  //       item.publicationId = publicationsMap[type][item.id].publicationId;
  //     }
  //     return item;
  //   };
  // }

  var baskets = response.lists.data.filter(filter("type", "BASKET"));
  var portfolios = response.lists.data.filter(filter("type", "PORTFOLIO"));
  var rankings = response.rankings;
  var strategies = response.strategies.data.filter(
    filter("entity_type", "BUILDER")
  );
  var systematicPortfolios = response.systematicPortfolios.data;
  var combinedStrategies = response.combinedStrategies;
  var screening = response.screening;
  var combinedProducts = response.combinedProducts;
  var publication: any = null;
  var publications = response.publications;
  var publicationsMap = {};
  for (var type in publications) {
    publicationsMap[type] = {};
    for (let i = 0; i < publications[type].length; i++) {
      publication = publications[type][i];
      publicationsMap[type][publication.id] = publication;
    }
  }

  baskets = baskets.map(map("lists"));
  portfolios = portfolios.map(map("lists"));
  rankings = rankings.map(map("rankings"));
  strategies = strategies.map(map("strategies"));
  systematicPortfolios = systematicPortfolios.map(map("systematicPortfolios"));
  combinedStrategies = combinedStrategies.map(map("combinedStrategies"));
  combinedProducts = combinedProducts.map(map("combinedProducts"));
  screening = screening.map(map("screening"));

  var data = {
    screening: screening,
    baskets: baskets,
    portfolios: portfolios,
    rankings: rankings,
    strategies: strategies,
    systematicPortfolios: systematicPortfolios,
    combinedStrategies: combinedStrategies,
    combinedProducts: combinedProducts,
    storeData: baskets
      .concat(portfolios)
      .concat(rankings)
      .concat(strategies)
      .concat(systematicPortfolios)
      .concat(screening),
  };
  return data;
};
